(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/reducer.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/redux/reducer.js');
"use strict";

var _greetings$;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  KEY,
  DOMAIN
} = svs.tickets_giftshop.constants.cache;
const {
  INPUT_SET_PERSONAL_GREETING,
  INPUT_SET_GREETING,
  INPUT_SET_NAME,
  INPUT_SET_EMAIL,
  INPUT_SET_PHONE,
  INPUT_SET_RECEIVER_TYPE,
  INPUT_SET_DATE,
  INPUT_SET_TIME,
  INPUT_SET_DATE_AND_TIME,
  INPUT_SET_DATE_TIME_AND_NAME,
  SET_DATE_SELECTOR,
  FORM_CLEAR
} = svs.tickets_giftshop.gift.giftform.actiontypes;
const {
  PHONE
} = svs.tickets_giftshop.constants.names;
const {
  NOW
} = svs.tickets_giftshop.constants.dateSelectorKey;
const cache = svs.components.Storage.browser.get(KEY, DOMAIN) || {};
const greetings = svs.tickets_giftshop.data.moduleConfig.greetings || [];
const personalGreeting = greetings.length > 0 && ((_greetings$ = greetings[0]) === null || _greetings$ === void 0 ? void 0 : _greetings$.greeting) || '';
const initState = () => ({
  personalGreeting: cache.personalGreeting || personalGreeting,
  name: cache.name || '',
  greeting: cache.greeting || '',
  email: cache.email || '',
  phone: cache.phone || '',
  receiverType: cache.receiverType || PHONE,
  date: cache.date || svs.utils.date.SimpleDate(new Date()),
  time: cache.time || svs.utils.date.FormatTime(),
  nameDayName: cache.nameDayName || '',
  dateSelector: cache.dateSelector || NOW,
  dateSelectorUsed: cache.dateSelectorUsed || NOW
});
function giftformReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState();
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case FORM_CLEAR:
      return {
        personalGreeting,
        name: '',
        greeting: '',
        email: '',
        phone: '',
        receiverType: PHONE,
        date: svs.utils.date.SimpleDate(new Date()),
        time: svs.utils.date.FormatTime(),
        nameDayName: '',
        dateSelector: NOW,
        dateSelectorUsed: NOW
      };
    case INPUT_SET_NAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        name: action.payload
      });
    case INPUT_SET_PERSONAL_GREETING:
      return _objectSpread(_objectSpread({}, state), {}, {
        personalGreeting: action.payload
      });
    case INPUT_SET_GREETING:
      return _objectSpread(_objectSpread({}, state), {}, {
        greeting: action.payload
      });
    case INPUT_SET_PHONE:
      return _objectSpread(_objectSpread({}, state), {}, {
        phone: action.payload
      });
    case INPUT_SET_EMAIL:
      return _objectSpread(_objectSpread({}, state), {}, {
        email: action.payload
      });
    case INPUT_SET_RECEIVER_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        receiverType: action.payload
      });
    case INPUT_SET_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        date: action.payload.date,
        dateSelectorUsed: action.payload.dateSelectorUsed
      });
    case INPUT_SET_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        time: action.payload.time,
        dateSelectorUsed: action.payload.dateSelectorUsed
      });
    case INPUT_SET_DATE_AND_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        date: action.payload.date,
        time: action.payload.time,
        dateSelectorUsed: action.payload.dateSelectorUsed
      });
    case INPUT_SET_DATE_TIME_AND_NAME:
      return _objectSpread(_objectSpread({}, state), {}, {
        date: action.payload.date,
        time: action.payload.time,
        nameDayName: action.payload.nameDayName,
        dateSelectorUsed: action.payload.dateSelectorUsed
      });
    case SET_DATE_SELECTOR:
      return _objectSpread(_objectSpread({}, state), {}, {
        dateSelector: action.payload
      });
    default:
      return state;
  }
}
svs.tickets_giftshop.gift.giftform.reducer = giftformReducer;

 })(window);